"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_ID = void 0;
exports.WIDGET_ID = 'CashierCheckoutWidget';
//# sourceMappingURL=config.js.map